import { createContext, useReducer, useEffect } from 'react'
import axios from 'axios'

export const AuthContext = createContext()

const apiBaseUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080/api'
    : 'https://artization.app/api')

export const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
})

// Public client — never attaches auth headers (landing page artwork preview)
export const publicAxios = axios.create({
  baseURL: apiBaseUrl,
})

// Add a request interceptor to include the token in every request
axiosInstance.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)

export const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { ...state, user: action.payload, isLoading: false }
        case 'LOGOUT':
            return { ...state, user: null, isLoading: false }
        case 'SET_LOADING':
            return { ...state, isLoading: action.payload }
        default: 
            return state
    }
}

export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
      user: null,
      isLoading: true,
    });
  
    useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      const verifyUser = async () => {
        try {
          dispatch({ type: 'SET_LOADING', payload: true });
          const response = await axiosInstance.get(`/auth/verify`);
          if (response && response.data?.user) {
            const updatedUser = { ...storedUser, ...response.data.user };
            localStorage.setItem('user', JSON.stringify(updatedUser)); 
            dispatch({ type: 'LOGIN', payload: updatedUser });
          }
        } catch (error) {
          console.log('Error verifying user:', error);
          localStorage.removeItem('user');
          dispatch({ type: 'LOGOUT' });
        } finally {
          dispatch({ type: 'SET_LOADING', payload: false });
        }
      };
  
      if (storedUser) {
        verifyUser();
      } else {
        console.log('No user found in localStorage');
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    }, []);
  
  
    return (
      <AuthContext.Provider value={{ ...state, dispatch }}>
        {children}
      </AuthContext.Provider>
    );
  };